<template>
  <section id="making-serum" class="making-serum-video-section">
    <h2
      class="making-serum-video-section__title u-typography-helvetica u-text-display u-text-display--s"
    >
      {{ $t('section.freshlyBlended.title') }}
    </h2>
    <video
      v-if="videoResource"
      ref="video"
      class="making-serum-video-section__video"
      playsinline="playsinline"
      autoplay
      loop
      muted
    >
      <source :src="videoResource" type="video/mp4" />
    </video>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';

import { hasProductPackIngredients } from '@/models/core/ProductPack';
import { getProductOptionsDefaultOption } from '@/models/core/ProductOptions';
import { getScreenSize } from '@/utils/common';

import { types } from '@/store/types';

import {
  VIDEO_RESOURCE_NAME,
  VIDEO_RESOURCE,
  RESPONSIVE_VIDEO_SIZE_MAP
} from '@/constants/responsiveVideo';
import { PRODUCT_NAMES } from '@/constants/treatment';

export default {
  name: 'MakingSerumVideoSection',
  data() {
    const screenSize = getScreenSize();
    const screenSizeMapped = RESPONSIVE_VIDEO_SIZE_MAP[screenSize];

    return { screenSize: screenSizeMapped };
  },
  computed: {
    ...mapGetters({
      allProductOptions: types.getters.ALL_PRODUCT_OPTIONS_SETS
    }),
    videoResourceName() {
      const faceSerumOptions = this.allProductOptions[PRODUCT_NAMES.FACE_SERUM];
      const faceSerum = getProductOptionsDefaultOption(faceSerumOptions);

      return hasProductPackIngredients(faceSerum)
        ? VIDEO_RESOURCE_NAME.SERUM_PACK
        : VIDEO_RESOURCE_NAME.EYE_CONTOUR_SERUM;
    },
    videoResource() {
      return VIDEO_RESOURCE[this.videoResourceName][this.screenSize].src;
    }
  }
};
</script>

<style lang="scss" scoped>
.making-serum-video-section {
  &__title {
    text-align: center;
    margin-bottom: 32px;
  }

  &__video {
    width: 100%;
    object-fit: cover;
  }
}

@media (min-width: 960px) {
  .making-serum-video-section {
    &__title {
      margin-bottom: 40px;
    }
  }
}
</style>
